module.exports = __webpack_public_path__ + "img/daniel_penhos.9d3250e1.jpg";